export default "__VITE_ASSET__AOTrJpQX__"